export const REPORT_LIBRARY_CATEGORIES = [
  'sales',
  'orders',
  'products',
  'payments',
  'processors',
  'subscriptions',
  'customers',
  'marketing',
  'acquisition',
  'conversion',
  'finance',
  'fraud',
  'integrations',
] as const;

export const REPORT_LIBRARY_ANALYSIS_FOCUSES = [
  'trend',
  'rate',
  'comparison',
  'composition',
  'snapshot',
  'funnel',
  'diagnostic',
  'geographic',
  'cyclical',
  'ranking',
  'latency',
  'financial',
] as const;
